// extracted by mini-css-extract-plugin
export default {"FormSelectInputRestart":"FormSelectInputRestart_FormSelectInputRestart__hv-Am"};